import { useState } from 'react';

import Toggle from './Toggle';
import Label from './form/Label';

const GenericCheckBox = ({
    id,
    label,
    labelComponent,
    tooltip,
    buttonTooltip = false,
    isRequired = false,
    initialValue,
    onChange,
    disabled,
    css = {}
}) => {
    const [currentValue, setCurrentValue] = useState(initialValue);

    return (
        <>
            <Label
                controlId={id}
                label={label}
                labelComponent={labelComponent}
                tooltip={tooltip}
                buttonTooltip={buttonTooltip}
                isRequired={isRequired}
            />
            <div className={`form-check form-switch ${css.toggle || ''}`}>
                <Toggle
                    id={id}
                    defaultState={initialValue}
                    disabled={disabled}
                    onChange={() => {
                        if (onChange) {
                            onChange(!currentValue)
                        }

                        setCurrentValue(prev => !prev)
                    }}
                />
            </div>
        </>
    );
};

export default GenericCheckBox;